import { render, staticRenderFns } from "./PauseOrdering.vue?vue&type=template&id=693eb16b&scoped=true&"
import script from "./PauseOrdering.vue?vue&type=script&lang=js&"
export * from "./PauseOrdering.vue?vue&type=script&lang=js&"
import style0 from "./PauseOrdering.vue?vue&type=style&index=0&id=693eb16b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693eb16b",
  null
  
)

export default component.exports